exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".single-select{width:90%}.single-select .multiselect__select:before{display:none}", ""]);

// exports
